class Systems {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.exportSystemsToCsv();
        this.tabChange();
        this.createSystemGroupForm();
        this.getSystemGroups().then(response => {
            let basicSystemFormInstance = new BasicSystemForm('frm-createSystemsForm-createSystemsForm', response);
            let advancedSystemFormInstance = new AdvancedSystemForm('frm-createAdvanceSystemsForm-createAdvanceSystemsForm', response);
            new DuplicateSystem(basicSystemFormInstance, advancedSystemFormInstance);
            let createSystemButton = document.querySelector('button[data-bs-target="#create_system_modal"]');
            if(createSystemButton){
                createSystemButton.addEventListener('click', function () {
                    basicSystemFormInstance.fillFormWithSystemInfo([], false);
                    advancedSystemFormInstance.fillFormWithSystemInfo([], false);
                });
            }
        });

        if (window.location.href.indexOf('#add_system') !== -1) {
            new bootstrap.Modal(document.getElementById('create_system_modal'), {}).show();
        }

        new GaClipboard().initByClass('gateway_ip_address-clipboard', 'secure_systems_modal');
    }
    createSystemGroupForm(){
        let addSystemGroupButtons = document.querySelectorAll('[data-action="add-system-group"]');
        let firstClick = true;
        addSystemGroupButtons.forEach((element) => {
            element.addEventListener('click', function (){
                if(firstClick){
                    new SystemGroupForm('frm-createSystemGroupForm-createSystemGroupForm');
                    firstClick = false;
                }
                bootstrap.Modal.getOrCreateInstance(document.getElementById('create_system_group_modal')).show();
            });
        });
    }
    async getSystemGroups(){
        return fetch('/systems/?do=getSystemGroups&organizationID=' + this.organizationID)
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }
    tabChange(){
        $('.systems-tab-menu .nav-link').on('click', function () {
            let toolbarToShow = $(this).attr('data-show-toolbar');
            $('.card-toolbar').addClass('d-none');
            if(toolbarToShow){
                $(toolbarToShow).removeClass('d-none');
            }
        });

        if(window.location.href.indexOf('#groups_tab') !== -1) {
            const groupsTab = document.querySelector('.nav-link[href="#groups_tab"]');
            bootstrap.Tab.getOrCreateInstance(groupsTab).show();
            $('.card-toolbar').addClass('d-none');
            $('.groups-toolbar').removeClass('d-none');
        }
    }
    exportSystemsToCsv(){
        let thisClass = this;
        let buttons = document.querySelectorAll('[data-action="export-systems-to-csv"]');
        buttons.forEach((button) => {
            button.addEventListener('click', function () {
                thisClass.downloadFile("/systems/get-systems-csv-export?organizationID="+thisClass.organizationID, 'systems.csv');
            });
        });
    }
    downloadFile(url, fileName){
        let loadingModal = document.getElementById('loading-modal');
        let hideModal = function () {
            setTimeout(function() {
                bootstrap.Modal.getOrCreateInstance(loadingModal).hide();
            }, 100);
        }
        new bootstrap.Modal(loadingModal).show();
        $.ajax({
            url: url,
            method: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data) {
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(data);
                a.href = url;
                a.download = fileName;
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                hideModal();
                toastr.success('Systems has been successfully downloaded!')
            },
            error: function (request, status, error) {
                hideModal();
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
            }
        });
    }
}
window.Systems = Systems;